import apiClient from './api';
import { Communique } from '../types/communique'; // سنحتاج لإنشاء هذا النوع
import { ServiceRequest } from '../types/serviceRequest'; // سنحتاج هذا النوع للنتائج
import { PagedResult, TableParams } from '../hooks/useServerSideTable';

// نوع بيانات لإنشاء بلاغ جديد
export interface NewCommuniqueData {
  communique_number: string;
  meeting_date: string; // نرسله كنص 'YYYY-MM-DD'
  summary?: string;
}

// نوع بيانات لفلاتر البحث العامة
export interface CommuniqueSearchFilters {
  communique_number?: string;
  applicant_name?: string;
}

/**
 * [ADMIN] إنشاء بلاغ جديد
 */
export const createCommunique = async (data: NewCommuniqueData): Promise<Communique> => {
  const response = await apiClient.post<{ data: Communique }>('/communiques', data);
  return response.data.data;
};

/**
 * [ADMIN] جلب قائمة البلاغات مع ترقيم
 */
export const getPagedCommuniques = async (params: TableParams): Promise<PagedResult<Communique>> => {
  const response = await apiClient.get<{ data: PagedResult<Communique> }>('/communiques/paged', { params });
  return response.data.data;
};

/**
 * [PUBLIC] البحث في نتائج البلاغات العامة
 * ملاحظة: نقطة النهاية هذه تعيد مصفوفة من ServiceRequest المرتبطة بالبلاغات
 */
export const searchPublicCommuniques = async (filters: CommuniqueSearchFilters): Promise<ServiceRequest[]> => {
  const response = await apiClient.get<{ data: ServiceRequest[] }>('/public/communiques/search', {
    params: filters,
  });
  return response.data.data;
};

export const getCommuniqueById = async (id: number): Promise<Communique> => {
  const response = await apiClient.get<{ data: Communique }>(`/communiques/${id}`);
  return response.data.data;
};
